import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ASSETS, BUY_URL, DEXSCREENER_URL, X_URL } from "@/config";
import { Corners, GlowButton, Reveal } from "@/components/ui-kit";
import ContractChip from "@/components/ContractChip";

const LAUNCH_LINES = [
  "> INITIALIZING...",
  "> CONNECTING TO ARC...",
  "> MACHINE NETWORK READY",
  "> ARCMECH ONLINE",
];

const LaunchPage = () => {
  const [lines, setLines] = useState(0);
  useEffect(() => {
    if (lines >= LAUNCH_LINES.length) return;
    const t = setTimeout(() => setLines((l) => l + 1), 550);
    return () => clearTimeout(t);
  }, [lines]);

  return (
    <div data-testid="launch-page" className="relative min-h-screen pb-24 overflow-hidden scanlines">
      <div className="absolute inset-0" aria-hidden="true">
        <img src={ASSETS.commandBg} alt="" className="w-full h-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-b from-arc-black/70 via-arc-black/50 to-arc-black" />
      </div>
      <div className="relative pt-32 px-5 sm:px-8 max-w-6xl mx-auto">
        <Reveal className="text-center">
          <div className="eyebrow mb-4">LAUNCH STATUS // NETWORK</div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-arc-white uppercase">
            ARCMECH IS <span className="text-arc-electric text-glow">ONLINE.</span>
          </h1>
        </Reveal>

        <Reveal delay={0.1} className="mt-8 max-w-xl mx-auto">
          <div className="hud-panel relative p-5 font-mono text-xs sm:text-sm leading-loose" data-testid="launch-terminal">
            <Corners />
            {LAUNCH_LINES.slice(0, lines).map((l, i) => (
              <div key={l} className={i === LAUNCH_LINES.length - 1 ? "text-arc-green" : "text-arc-silver/70"}>
                {l}{i === LAUNCH_LINES.length - 1 && <span className="anim-blink">_</span>}
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.2} className="mt-10">
          <div className="hud-panel relative p-2 max-w-4xl mx-auto">
            <Corners />
            <img src={ASSETS.banner} alt="ARCMECH launch artwork — orbital machine network" className="w-full h-auto" />
          </div>
        </Reveal>

        <Reveal delay={0.3} className="mt-10 max-w-3xl mx-auto">
          <div className="hud-panel relative p-6 sm:p-8">
            <Corners />
            <div className="grid sm:grid-cols-2 gap-4 font-mono text-xs tracking-[0.15em] mb-8">
              {[["TOKEN", "$ARCMECH", "text-arc-white"], ["NETWORK", "ARC", "text-arc-white"], ["CONTRACT", "0x5e01…f5aD", "text-arc-cyan"], ["BUY", "ARGUS", "text-arc-cyan"], ["X", "@ARCMECH", "text-arc-cyan"], ["CHART", "DEXSCREENER", "text-arc-cyan"]].map(([k, v, c]) => (
                <div key={k} className="border border-arc-blue/15 p-3 flex justify-between items-center">
                  <span className="text-arc-silver/40 text-[10px] tracking-[0.3em]">{k}</span>
                  <span className={c}>{v}</span>
                </div>
              ))}
            </div>
            <div className="flex flex-wrap gap-4 justify-center">
              <GlowButton href={BUY_URL} testId="launch-buy-button" cursor="TARGET">BUY $ARCMECH</GlowButton>
              {DEXSCREENER_URL ? (
                <GlowButton href={DEXSCREENER_URL} variant="ghost" testId="launch-chart-button" cursor="OPEN">VIEW CHART</GlowButton>
              ) : (
                <GlowButton variant="ghost" testId="launch-chart-button" className="opacity-60 cursor-not-allowed" cursor="SCAN">VIEW CHART — COMING SOON</GlowButton>
              )}
              <GlowButton href={X_URL} variant="cyan" testId="launch-x-button" cursor="OPEN">FOLLOW ON X</GlowButton>
            </div>
            <div className="mt-6 flex flex-col items-center gap-2">
              <ContractChip />
              <span className="font-mono text-[9px] tracking-[0.25em] text-arc-silver/40">ALWAYS VERIFY VIA @ARCMECH ON X</span>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  );
};

export default LaunchPage;
